import { NormalText } from "components/styled/text.styled";
import styled from "styled-components";
import { Stack } from "@mui/material";
import CounterButton from "components/Counter";
import { formatCurrency } from "helper/general";
import { MiniTimesGrayIcon } from "assets/icons";
import React from "react";
import NoPhoto from "assets/images/no-product-photo.svg";


export interface ICartItem {
  image: string;
  price: number;
  original_price?: number;
  discount?: number;
  discount_type?: string;
  category: string;
  name: string;
  qty: number;
  onIncrease: any;
  onDecrease: any;
  onRemove: any;
  additional?: ICartItemAddons[];
}

export interface ICartItemAddons {
  name: string;
  price: number;
  qty: number;
  product_price_after_discount: number;
}

const CartItem = ({
  image,
  price,
  original_price,
  discount = 0,
  discount_type,
  category,
  name,
  qty,
  onIncrease,
  onDecrease,
  additional,
  onRemove,
}: ICartItem) => { 
  let totalPriceAdditional = 0 
  if(additional && additional.length > 0){
    additional.forEach((addon) => {
      console.log("addon", addon);
      
        totalPriceAdditional += Number(addon.product_price_after_discount) * addon.qty
    })
  }

  const [imageError, setImageError] = React.useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const hasDiscount = discount && discount > 0 && original_price && original_price > price;

  return (
    <Container>
      <XButton src={MiniTimesGrayIcon} alt={"remove_ic"} onClick={onRemove} />
      
      <Stack direction={"row"} spacing={1} justifyContent={"space-between"}>
        <Stack direction={"row"} spacing={1} alignItems="center">
          <ImageWrapper>
            {hasDiscount ? (
              <DiscountFlag>
                {discount_type === "percent"
                  ? `${discount}% off`
                  : `${formatCurrency(discount)} IDR off`
                }</DiscountFlag>
            ): null}
            {imageError ? (
              <ProductImage
                src={NoPhoto}
                alt={"Product"}
              />
            ) : (
              <ProductImage
                src={image}
                alt={"Product"}
                onError={handleImageError}
              />
            )}
          </ImageWrapper>
          <Stack direction={"column"} justifyContent={"space-between"}>
            <NormalText color={"#A3A3A3"} fontSize={"12px"}>
              {category}
            </NormalText>
            <NormalText color={"#010101"} fontSize={"15px"} fontWeight={"bold"}>
              {name}
            </NormalText>
            {additional &&
              additional.length > 0 &&
              additional.map((addon, index) => (
                <NormalText
                  key={"addon-" + index}
                  color={"#010101"}
                  fontSize={"12px"}
                >
                  + {addon.name}
                </NormalText>
              ))}
          </Stack>
        </Stack>
        <Stack direction={"column"} justifyContent={"space-between"} alignItems="flex-end">
          <div style={{ textAlign: "right" }}>
            {hasDiscount ? (
              <Stack direction="column" alignItems="flex-end" spacing={0.2}>
                <NormalText 
                  color={"#666"} 
                  fontSize={"12px"} 
                  style={{ textDecoration: "line-through", opacity: 0.7, whiteSpace: 'nowrap' }}
                >
                  {formatCurrency(Number((original_price! + totalPriceAdditional) * qty))}
                </NormalText>
                <NormalText color={"black"} fontSize={"15px"} fontWeight={"bold"} style={{ whiteSpace: 'nowrap' }}>
                  {formatCurrency(Number((price + totalPriceAdditional) * qty))}
                </NormalText>
              </Stack>
            ) : (
              <NormalText color={"black"} fontSize={"15px"} style={{ whiteSpace: 'nowrap' }}>
                {formatCurrency(Number((price + totalPriceAdditional) * qty))}
              </NormalText>
            )}
          </div>
          <CounterButton
            buttonWidth="20px"
            value={qty}
            onIncrease={onIncrease}
            onDecrease={onDecrease}
          />
        </Stack>
      </Stack>
    </Container>
  );
};

const DiscountFlag = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #f00b38;
  font-size: 8px;
  padding: 2px 4px;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 8px;
  color: white;
  font-weight: bold;
  z-index: 3;
`;

const Container = styled.div`
  width: 100%;
  position: relative;
  min-height: 70px;
  background: white;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  margin: 10px 0;
  padding: 10px;
`;

const XButton = styled.img`
  user-select: none;
  -webkit-user-drag: none;
  position: absolute;
  right: -7px;
  top: -7px;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 60px;
  height: 55px;
  flex-shrink: 0;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
`;


export default CartItem;